import { Controller } from '../utils/controller';

export default class extends Controller {
  static targets = ['rules', 'password'];

  static values = {
    lowercaseRegexp: {
      type: String,
      default: ''
    },
    lowercaseMessage: {
      type: String,
      default: ''
    },
    numberRegexp: {
      type: String,
      default: ''
    },
    numberMessage: {
      type: String,
      default: ''
    },
    uppercaseRegexp: {
      type: String,
      default: ''
    },
    uppercaseMessage: {
      type: String,
      default: ''
    },
    minlengthRegexp: {
      type: String,
      default: ''
    },
    minlengthMessage: {
      type: String,
      default: ''
    }
  };

  //TARGETS
  declare rulesTarget: HTMLElement;
  declare passwordTarget: HTMLInputElement;

  declare readonly hasRulesTarget: boolean;
  declare readonly hasPasswordTarget: boolean;

  // VALUES
  declare lowercaseRegexpValue: string;
  declare lowercaseMessageValue: string;
  declare numberRegexpValue: string;
  declare numberMessageValue: string;
  declare uppercaseRegexpValue: string;
  declare uppercaseMessageValue: string;
  declare minlengthRegexpValue: string;
  declare minlengthMessageValue: string;

  // LOCAL STATE
  private invisibleClass: string;
  private regexps: string[];

  initialize() {
    this.invisibleClass = 'invisible';
    this.regexps = ['lowercase', 'number', 'uppercase', 'minlength'];
  }

  display() {
    this.hasRulesTarget && this.rulesTarget.classList.remove(this.invisibleClass);
    this.validate(this.passwordTarget.value);
  }

  hide() {
    this.hasRulesTarget && this.rulesTarget.classList.add(this.invisibleClass);
    this.emptyRules();
  }

  toSpan(message: string) {
    return `<span>${message}</span>`;
  }

  emptyRules() {
    this.rulesTarget.innerHTML = '';
  }

  iconX() {
    return '<span class="text-red-500">X</span>';
  }

  iconCheckmark() {
    return '<span class="text-[#07bb5b]">✓</span>';
  }

  handleChange(event: Event) {
    this.validate((event.target as HTMLInputElement).value);
  }

  validate(password: string) {
    this.emptyRules();

    let valid = true;
    for (const regexp of this.regexps) {
      const actual_regexp = this[`${regexp}RegexpValue`] as string;
      const actual_message = this[`${regexp}MessageValue`] as string;

      if (actual_regexp) {
        const icon = new RegExp(actual_regexp).test(password) ? this.iconCheckmark() : this.iconX();
        this.rulesTarget.innerHTML += this.toSpan(`${icon} ${actual_message}`);

        if (icon == this.iconX()) {
          valid = false;
        }
      }
    }

    this.passwordTarget.setAttribute('is-valid', `${valid}`);
  }
}
